import React from "react";
import { Modal } from "reactstrap";

import GoalPlanForm from "./GoalPlanForm";
const AddGoalPlanModal = ({
  program,
  isOpen,
  toggle,
}) => {
  const props = {
    program,
    toggle,
  };

  return (
    <Modal
      className="program-settings manager-program-settings-modal modal-xl"
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="manager-program-settings-modal__layout">
        <div className="manager-program-settings-modal__main">
          <div className="manager-program-settings-modal__header">
            <div className="manager-program-settings-modal__header-copy">
              <h3 className="manager-program-settings-modal__title">Add New Goal Plan</h3>
              <p className="manager-program-settings-modal__subtitle">
                Create a goal plan for this program.
              </p>
            </div>
            <button
              type="button"
              className="manager-program-settings-modal__close"
              onClick={toggle}
              aria-label="Close"
            >
              Close
            </button>
          </div>
          <div className="manager-program-settings-modal__body">
            <GoalPlanForm {...props} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddGoalPlanModal;
